/** Automatisch terug naar het scanscherm; iedere scan herstart de timer. */
import { useEffect, useRef } from 'react';

/**
 * @param actief    of de timer loopt (rooster zichtbaar)
 * @param duurMs    hoe lang na het (her)starten er uitgelogd wordt
 * @param onVerlopen wordt één keer geroepen als de tijd om is
 */
export function useAutoUitlog(actief: boolean, duurMs: number, onVerlopen: () => void, scanTeller = 0): void {
  // Via een ref, zodat een nieuwe callback bij elke render de timer niet
  // opnieuw laat beginnen.
  const verlopen = useRef(onVerlopen);
  verlopen.current = onVerlopen;

  useEffect(() => {
    if (!actief) return;
    const id = setTimeout(() => verlopen.current(), duurMs);
    return () => clearTimeout(id);
  }, [actief, duurMs, scanTeller]);
}
